import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiCallService } from 'app/shared/services/common/api.service';
import { CommonService } from 'app/shared/services/common/common.service';
import { AppSnackBarService } from 'app/shared/services/snackBar.service';
import { DateAdapter } from '@angular/material/core';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

  public eventDateFilter: any = [];
  public eventTypeFilter: any = [];
  public eventTherapeticsFilter: any = [];
  public dateFilter: any = [];
  public typeFilter: any = [{
    name: 'All types',
    value: '',
  }];
  public therapeticFilter: any = [];
  public enableAllTherapeutics: boolean = true;
  public statDate: any;
  public endDate: any;
  public minDate = new Date();
  public filterForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<FilterComponent>,
    private apiCallService: ApiCallService,
    public commonService: CommonService,
    private appSnackBarService: AppSnackBarService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.filterForm = this.fb.group({
      startDate: [''],
      endDate: ['']
    }, { validator: this.checkDates });

    this.apiCallService.createHttp('get', this.commonService.GetTherapeuticList).subscribe(response => {
      if (response.status == 200) {
        this.eventTherapeticsFilter = response.body.result.docs;
        if (this.eventTherapeticsFilter.length > 0 && this.data.filterData && this.data.filterData.therapetic) {
          for (let i = 0; i <= this.data.filterData.therapetic.length; i++) {
            this.eventTherapeticsFilter.forEach((element: any, index: number) => {
              if (this.data.filterData.therapetic[i] == element.id) {
                element.enable = true;
              }
            });
          }

        }
      }
    });
    if (this.data && this.data.filterData) {
      this.therapeticFilter = (this.data.filterData.therapetic) ? this.data.filterData.therapetic : [];
      this.typeFilter = (this.data.filterData.eventType) ? this.data.filterData.eventType : [];
      this.dateFilter = (this.data.filterData.dateFilter) ? this.data.filterData.dateFilter : [];
      if (this.data.filterData.dateFilter[0]) {
        this.filterForm.patchValue({
          startDate: new Date(this.data.filterData.dateFilter[0].statDate),
          endDate: new Date(this.data.filterData.dateFilter[0].endDate)
        });
      }
    }
  }

  ngOnInit(): void {

    this.eventTypeFilter = [
      {
        name: 'All types',
        value: '',
      },
      {
        name: 'In person',
        value: 'INPERSON',
      },
      {
        name: 'Online Webinar',
        value: 'ONLINE',
      },
    ];
    this.filterForm.get('startDate').valueChanges
      .subscribe(flag => {
        if (flag) {
          this.filterForm.controls['endDate'].reset();
        }
      })
  }

  checkDates(group: FormGroup) {
    if (group.controls.endDate.value < group.controls.startDate.value) {
      return { notValid: true }
    }
    return null;
  }

  close(data?: any): void {
    this.dialogRef.close(data);
  }

  public selectDateFilter(data): void {
    let currentDate = moment().toDate();
    let params: any = {};
    if (data == 'Today') {
      params.name = data;
      params.statDate = moment(currentDate).format('YYYY-MM-DD');
      params.endDate = '';
    } else if (data == 'Tomorrow') {
      let tomorrow = moment().add(1, 'days')
      params.name = data;
      params.statDate = moment(tomorrow).format('YYYY-MM-DD');
      params.endDate = '';
    } else if (data == 'This week') {
      const startOfWeek = moment().startOf('week');
      const endOfWeek = moment().endOf('week');
      params.name = data;
      params.statDate = moment(startOfWeek).format('YYYY-MM-DD');
      params.endDate = moment(endOfWeek).format('YYYY-MM-DD');
    } else if (data == 'Choose dates') {
      params.name = data;
    } else if (data == 'All upcoming') {
      params.name = data;
      delete this.dateFilter;
    }
    this.dateFilter = [];
    this.dateFilter.push(params);
  }

  public enableAllTherapeutic(): void {
    this.enableAllTherapeutics = !this.enableAllTherapeutics
  }

  public applyFilter(): void {
    let filterValid = true;
    this.therapeticFilter = [];
  
    if (this.eventTherapeticsFilter.length > 0) {
      this.eventTherapeticsFilter.forEach(element => {
        if (element.enable) {
          this.therapeticFilter.push(element.id);
        }
      });
    }
  
    if (this.filterForm.get('startDate').value || this.filterForm.get('endDate').value) {
      this.dateFilter = [{
        name: '',
        value: ''
      }];
      this.dateFilter[0].name = 'Choose dates';
      this.dateFilter[0].statDate = moment(this.filterForm.get('startDate').value).format('YYYY-MM-DD');
      this.dateFilter[0].endDate = moment(this.filterForm.get('endDate').value).format('YYYY-MM-DD');
    }
  
    if ((this.filterForm.get('startDate').value && !this.filterForm.get('endDate').value) ||
        (!this.filterForm.get('startDate').value && this.filterForm.get('endDate').value)) {
      filterValid = false;
      this.appSnackBarService.showSnackbar('Please select dates', 'error', "", 2000, 'top', 'end');
    }
  
    let params: any = {
      eventType: this.typeFilter,
      therapetic: this.therapeticFilter
    };
  
    if (this.dateFilter) {
      params.dateFilter = this.dateFilter;
    }
  
    console.log(filterValid, this.filterForm.valid);
  
    if ((params.dateFilter?.length > 0 || params.therapetic.length > 0) && filterValid) {
      this.close(params);
    } else if (filterValid) {
      this.appSnackBarService.showSnackbar('Please select any filter', 'error', "", 2000, 'top', 'end');
    }
  }
  

}
